import { useCallback } from 'react';

import usePressTracing from '@atlaskit/react-ufo/use-press-tracing';

const prefix = 'editor-ai.submit-prompt';

const useUfoPromptTracing = (): (agent: "atlassian-intelligence" | "rovo") => void => {
	const ufoAtlassianIntelligenceTracing = usePressTracing(`${prefix}.atlassian-intelligence`);
	const ufoRovoTracing = usePressTracing(`${prefix}.rovo`);

	return useCallback(
		(agent: 'atlassian-intelligence' | 'rovo') => {
			const tracing = agent === 'rovo' ? ufoRovoTracing : ufoAtlassianIntelligenceTracing;
			tracing();
		},
		[ufoAtlassianIntelligenceTracing, ufoRovoTracing],
	);
};

export default useUfoPromptTracing;
